export const QUERY_CONDITION_LOCALE_ZHCHT = {
    configDialog: {
        unSelectedOptions: 'æªé¸æé ',
        selectedOptions: 'å·²é¸æé ',
        confirm: 'ç¢ºå®',
        cancel: 'åæ¶',
        placeholder: 'è«è¼¸å¥æç´¢ééµå­',
        moveUp: 'ä¸ç§»',
        moveAllUp: 'å¨é¨ä¸ç§»',
        moveDown: 'ä¸ç§»',
        moveAllDown: 'å¨é¨ä¸ç§»',
        moveRight: 'å³ç§»',
        moveAllRight: 'å¨é¨å³ç§»',
        moveLeft: 'å·¦ç§»',
        moveAllLeft: 'å¨é¨å·¦ç§»',
        pleaseSelect: 'è«é¸æå­æ®µ',
        noOptionMove: 'åæå¯ç§»åå­æ®µ',
        selectOptionUp: 'è«é¸æä¸ç§»å­æ®µ',
        cannotMoveUp: 'ç¡æ³ä¸ç§»',
        selectOptionTop: 'è«é¸æç½®é å­æ®µ',
        optionIsTop: 'å­æ®µå·²ç½®é ',
        selectOptionDown: 'è«é¸æä¸ç§»å­æ®µ',
        cannotMoveDown: 'ç¡æ³ä¸ç§»',
        selectOptionBottom: 'è«é¸æç½®åºå­æ®µ',
        optionIsBottom: 'å­æ®µå·²ç½®åº'
    },
    container: {
        query: 'ç¯©é¸',
        saveAs: 'å¦å­çº',
        save: 'ä¿å­',
        config: 'éç½®'
    }
};
